import { RelativeTaxRateStrategy } from '@mews-distributor/common';
import { LocalizedPercent } from '@mews/framework/localization';

interface RelativeTaxRateProps {
    strategy: RelativeTaxRateStrategy;
}

export const RelativeTaxRate: React.FC<RelativeTaxRateProps> = ({ strategy }) => (
    <LocalizedPercent percent={strategy.value} />
);
